import React, { useEffect, useRef } from 'react';
import styles from './TedxSection.module.css';
import tedx from '../../assets/tedx.svg';

// --- Reusable Scroll Reveal Hook ---
const useScrollReveal = () => {
    const ref = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add(styles.animateIn);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0.15 } // Triggers when 15% is visible
        );

        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);
    return ref;
};

const TedxSection = () => {
    // Refs for animating each row individually
    const row1Ref = useScrollReveal();
    const row2Ref = useScrollReveal();

    return (
        <div className={styles.container}>
            {/* ─── ROW 1 ─── */}
            <div ref={row1Ref} className={`${styles.main} ${styles.revealUp}`}>
                <div className={styles.info}>
                    <div className={styles.channel}>
                        <img src={tedx} alt="TEDx" className={styles.tedxLogo} />
                        <span>TEDx Talks</span>
                    </div>
                    <h4 className={styles.videoTitle}>
                        Build Before You're Seen | Faisal Khan | TEDxNM College
                    </h4>
                    <p className={styles.description}>
                        What does it take to turn passion into a lifelong career? In this talk, Faisal Khan shares how consistency, self-reliance, and timing helped him build one of India’s leading auto content platforms from scratch. It's a raw look at the long road behind “overnight success.” Faisal Khan, Founder of MotorBeam and an acclaimed auto journalist, is a passionate automotive expert known for his in-depth reviews, industry insights, and dedication to bringing the latest trends to car enthusiasts.
                    </p>
                </div>

                <div className={styles.videoContainer}>
                    <div className={styles.cardStyle}>
                        <div className={styles.videoWrapper}>
                            <iframe
                                className={styles.iframeStyle}
                                src="https://www.youtube.com/embed/aeAr-4ButrE?si=1iVjDOiEbWLVI9AW&rel=0&modestbranding=1"
                                title="Build Before You're Seen | Faisal Khan | TEDxNM College"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                loading="lazy"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>

            {/* ─── ROW 2 ─── */}
            <div ref={row2Ref} className={`${styles.main} ${styles.revealUp}`}>
                <div className={styles.info}>
                    <div className={styles.channel}>
                        <img src={tedx} alt="TEDx" className={styles.tedxLogo} />
                        <span>TEDx Talks</span>
                    </div>
                    <h4 className={styles.videoTitle}>
                        Unlocking the Power of Originality in a World of Imitation | Faisal Khan | TEDxCRCE
                    </h4>
                    <p className={styles.description}>
                        He shares his journey from a passionate automotive enthusiast to a successful digital content creator. He talks about how he started by leaving comments on forums, writing blogs and articles daily, and eventually launching his own domain, "MotorBeam." Balancing his schooling and college with building his website, Faisal emphasizes the importance of starting your passion projects as early as possible.
                    </p>
                </div>

                <div className={styles.videoContainer}>
                    <div className={styles.cardStyle}>
                        <div className={styles.videoWrapper}>
                            <iframe
                                className={styles.iframeStyle}
                                src="https://www.youtube.com/embed/jnvI53KqkR8?si=2RyvDIIls3V3q7Ms&rel=0&modestbranding=1"
                                title="Unlocking the Power of Originality in a World of Imitation | Faisal Khan | TEDxCRCE"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                loading="lazy"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TedxSection;